import * as types from "../../actions/ActionTypes"
const initialState = {
    data: [],
    loading: false,
    error: null,
};
const SignUpReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.POST_SIGNUP_START:
      return {
        ...state,
        loading: true,
        
      };
    case types.POST_SIGNUP_SUCCESS:  
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case types.POST_SIGNUP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default SignUpReducer;